import { ReactElement, Suspense } from 'react';
import { useSelector } from 'react-redux';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { lazy } from 'utils/generic/lazy';
import { FavoriteSideBarSection } from './partials/FavoriteSideBarSection';
import { SearchElement } from 'newelements/SearchElement';
import {
  ESearchElementSearchType,
  TSearchActions
} from 'newelements/SearchElement/partials/types';
import { SportTournament } from 'components/Shared/SportTournament';
import { FetchFavoriteMatchIds } from 'newcomponents/Shared/sportsbook/Favorite/FetchFavoriteMatchIds';
import { FavoriteTeamSkeleton } from 'newcomponents/Shared/sportsbook/FavoriteTeam/Skeleton';
import { useSportsbookConfigs } from 'hooks/sportsbook/useSportsbookConfigs';
import {
  getIsLoggedIn,
  getPersonalisedDataLoaded
} from 'store/selectors/user-data';

const { Homework } = lazy(
  () =>
    import(/* webpackChunkName: "homework" */ 'newelements/Generics/homework')
);

const { FavoriteTeam } = lazy(
  () =>
    import(
      /* webpackChunkName: "my-favorite-team" */ 'newcomponents/Shared/sportsbook/FavoriteTeam'
    )
);

type TFavoriteSideBarSearchSectionProps = {
  showFavoriteTeam?: boolean;
  favoriteTeamCallback?: (id: string) => void;
  searchCallback?: (params: TSearchActions) => void;
};

export const FavoriteSideBarSearchSection = ({
  searchCallback,
  showFavoriteTeam
}: TFavoriteSideBarSearchSectionProps): ReactElement => {
  const config = useSportsbookConfigs();
  const personalisedDataLoaded = useSelector(getPersonalisedDataLoaded);
  const isLoggedIn = useSelector(getIsLoggedIn);

  return (
    <>
      {SpringConfigs.USER_PERSONALIZATION_ENABLED ? (
        isLoggedIn && personalisedDataLoaded ? (
          <FetchFavoriteMatchIds />
        ) : null
      ) : (
        <FetchFavoriteMatchIds />
      )}

      <FavoriteSideBarSection />

      {SpringConfigs.SPORT_TOURNAMENTS && +config.spbLayoutType === 0 && (
        <div className="left-sidebar-tournament__wrapper">
          <SportTournament />
        </div>
      )}

      {showFavoriteTeam && (
        <div
          className="left-sidebar-favorite__wrapper"
          data-testid="my-favorite"
        >
          <Suspense fallback={<FavoriteTeamSkeleton />}>
            <FavoriteTeam />
          </Suspense>
        </div>
      )}

      {SpringConfigs.HOMEWORK_ENABLED ? (
        <Suspense>
          <Homework />
        </Suspense>
      ) : null}

      <div className="search__sportsBook">
        <SearchElement
          externalSportRedirect={
            searchCallback
              ? params => {
                  searchCallback(params);
                }
              : undefined
          }
          configs={{
            searchType: ESearchElementSearchType.SPORT
          }}
        />
      </div>
    </>
  );
};
